import _ from 'lodash';

export const checkWhichCategoryIsThisGroupIn = (
  maxChoiceIsActive: 0 | 1,
  maxChoiceNum: 0 | 1,
  maxPerIsActive: 0 | 1,
  maxPerNum: 0 | 1,
  minChoiceIsActive: 0 | 1,
  minChoiceNum: 0 | 1,
) => {
  const isChooseOneOnly =
    maxChoiceIsActive === 1 && maxChoiceNum == 1 && minChoiceIsActive === 1 && minChoiceNum === 1
      ? true
      : false;

  const isAddOnce =
    minChoiceIsActive === 1 && minChoiceNum >= 1 && maxPerIsActive === 1 && maxPerNum === 1
      ? true
      : false;

  const isAddMultiple = !isChooseOneOnly && !isAddOnce ? true : false;

  if (isChooseOneOnly) {
    return 'chooseOneOnly';
  }
  if (isAddOnce) {
    return 'canAddOnce';
  }
  if (isAddMultiple) {
    return 'canAddMultiple';
  }
  return '';
};

export const getModifierGroups = (modifierGroup: any) => {
  let chooseOneOnlyGroup: any = [];
  let addOneGroup: any = [];
  let addMultipleGroup: any = [];

  for (let i = 0; i < modifierGroup.length; i++) {
    const currentGroup = modifierGroup[i];

    const checkRet = checkWhichCategoryIsThisGroupIn(
      currentGroup.maxChoiceIsActive,
      currentGroup.maxChoiceNum,
      currentGroup.maxPerIsActive,
      currentGroup.maxPerNum,
      currentGroup.minChoiceIsActive,
      currentGroup.minChoiceNum,
    );

    if (checkRet === 'chooseOneOnly') {
      chooseOneOnlyGroup.push({
        id: currentGroup.id,
        name: currentGroup.name,
        required: currentGroup.required,
        minChoiceNum: currentGroup.minChoiceNum,
        items: currentGroup.items.map((x: any) => ({ ...x, choosed: false })),
      });
      continue;
    }
    if (checkRet === 'canAddOnce') {
      addOneGroup.push({
        id: currentGroup.id,
        name: currentGroup.name,
        required: currentGroup.required,
        minChoiceNum: currentGroup.minChoiceNum,
        items: currentGroup.items.map((x: any) => ({ ...x, checked: false })),
      });
      continue;
    }
    if (checkRet === 'canAddMultiple') {
      addMultipleGroup.push({
        id: currentGroup.id,
        name: currentGroup.name,
        required: currentGroup.required,
        minChoiceNum: currentGroup.minChoiceNum,
        items: currentGroup.items.map((x: any) => ({ ...x, number: 0 })),
      });
      continue;
    }
  }

  const modifierOptions = {
    chooseOneOnlyGroup,
    addOneGroup,
    addMultipleGroup,
  };

  return modifierOptions;
};

export const getModifierItemListFromDishPage = (modifierOptions: any) => {
  let sum: any | string = [];

  _.forEach(modifierOptions.chooseOneOnlyGroup, (group: any) => {
    let singleGroupItems: any = [];
    group.items.map((item: any) => {
      if (item.choosed) {
        singleGroupItems.push({
          modifier_group_id: group.id,
          modifier_item_id: item.id,
          quantity: 1,
        });
      }
      return item;
    });

    if (group.required && singleGroupItems.length < group.minChoiceNum) {
      sum = 'missingRequiredModifier';
    } else {
      if (typeof sum !== 'string') {
        singleGroupItems.map((x: any) => {
          sum.push(x);
        });
      }
    }
  });
  if (typeof sum === 'string') {
    return sum;
  }
  _.forEach(modifierOptions.addOneGroup, (group: any) => {
    let singleGroupItems: any = [];
    group.items.map((item: any) => {
      if (item.checked) {
        singleGroupItems.push({
          modifier_group_id: group.id,
          modifier_item_id: item.id,
          quantity: 1,
        });
      }
      return item;
    });

    if (group.required && singleGroupItems.length < group.minChoiceNum) {
      sum = 'missingRequiredModifier';
    } else {
      if (typeof sum !== 'string') {
        singleGroupItems.map((x: any) => {
          sum.push(x);
        });
      }
    }
  });

  if (typeof sum === 'string') {
    return sum;
  }

  _.forEach(modifierOptions.addMultipleGroup, (group: any) => {
    let singleGroupItems: any = [];
    group.items.map((item: any) => {
      if (item.number >= 1) {
        singleGroupItems.push({
          modifier_group_id: group.id,
          modifier_item_id: item.id,
          quantity: item.number,
        });
      }
      return item;
    });

    if (group.required) {
      //不能简单的就下定论 需要进一步讨论只有一个item点了很多次的情况
      if (singleGroupItems.length < group.minChoiceNum) {
        //做一个count统计
        let count = 0;
        _.forEach(singleGroupItems, (item: any) => {
          count += item.number;
        });
        if (count < group.minChoiceNum) {
          sum = 'missingRequiredModifier';
        } else {
          if (typeof sum !== 'string') {
            singleGroupItems.map((x: any) => {
              sum.push(x);
            });
          }
        }
      } else {
        if (typeof sum !== 'string') {
          singleGroupItems.map((x: any) => {
            sum.push(x);
          });
        }
      }
    } else {
      if (typeof sum !== 'string') {
        singleGroupItems.map((x: any) => {
          sum.push(x);
        });
      }
    }
  });

  if (typeof sum === 'string') {
    return sum;
  }

  return sum;
};
